import { Rte } from '../atoms'

const RteItem = ({ blok, ...props }) => {
  const { text, indented } = blok ?? {}

  return <Rte content={text} indented={{ true: true, false: false }[indented]} {...props} />
}
export default RteItem
